import type { EntityType } from '@repo/common/enums/entityType';
import { observer } from 'mobx-react-lite';
import type { IComment, ISecodaEntity } from '../../api';
import { AIAssistantSidebar } from '../../components/AIAssistant/AIAssistantSidebar/AIAssistantSidebar';
import { getEntityPageSidebarProps } from '../../components/EntityDrawer/utils';
import EntityPageSidebar from '../../components/EntityPageLayout/EntityPageSidebar';
import type { SidebarEntityKeys } from '../../components/EntityPageLayout/types';
import type { WithOnlyIdRequired } from '../../lib/typescript';
import type { DjangoValueType } from '../../pages/TemplatePage/types';
import {
	RightSidebarMode,
	RightSidebarWrapper,
	rightSidebarStore,
} from '../RightSidebar';
import FixedCommentSidebar from './FixedCommentSidebar/FixedCommentSidebar';

interface CommentSidebarProps {
	entity: ISecodaEntity;
	commentThreads: { [rootID: string]: IComment[] };
	handleCreateComment: (
		data: Partial<Omit<IComment, 'id'>>
	) => Promise<IComment>;
	handleUpdateComment: (data: WithOnlyIdRequired<IComment>) => Promise<void>;
	handleDeleteComment: (commentId: string) => Promise<void>;
	updateEntity: (
		key: SidebarEntityKeys,
		value: DjangoValueType,
		saveRemotely?: boolean
	) => void;
	source?: 'Secoda' | 'Confluence';
	entityType: EntityType;
}

export const CommentSidebar = observer(
	({
		entity,
		commentThreads,
		handleCreateComment,
		handleUpdateComment,
		handleDeleteComment,
		updateEntity,
		source = undefined,
		entityType,
	}: CommentSidebarProps) => (
		<RightSidebarWrapper>
			{rightSidebarStore.mode === RightSidebarMode.INFO && (
				<EntityPageSidebar
					entity={entity}
					updateEntity={updateEntity}
					withSource={source}
					{...getEntityPageSidebarProps(entityType)}
				/>
			)}
			{rightSidebarStore.mode === RightSidebarMode.COMMENT && (
				<FixedCommentSidebar
					commentThreads={commentThreads || {}}
					handleCreateComment={handleCreateComment}
					handleUpdateComment={handleUpdateComment}
					handleDeleteComment={handleDeleteComment}
				/>
			)}
			{rightSidebarStore.mode === RightSidebarMode.AI && <AIAssistantSidebar />}
		</RightSidebarWrapper>
	)
);
